<!--Registration Page Starts-->
<section id="regestration">
  <div class="row auth-height full-height-vh m-0">
    <div class="col-12 d-flex align-items-center justify-content-center">
      <div class="card overflow-hidden">
        <div class="card-content">
          <div class="card-body auth-img">
            <div class="row m-0">
              <div
                class="col-lg-6 d-none d-lg-flex justify-content-center align-items-center text-center auth-img-bg py-2"
              >
                <img
                  src="assets/img/gallery/register.png"
                  alt=""
                  class="img-fluid"
                  width="350"
                  height="230"
                />
              </div>
              <div class="col-lg-6 col-md-12 px-4 py-3">
                <h4 class="card-title mb-2">Connect to learn</h4>
                <p>Fill the below form to show interest</p>

                <form [formGroup]="registerForm">
                  <!-- <div class="form-group">
                    <label for="users-list-role">Role</label>
                      <fieldset class="form-group">
                        <select id="users-list-role" class="form-control"  [(ngModel)]="selectedValue"  [ngModelOptions]="{standalone: true}" (change)="getRoleId($event)">
                          <option value="Select Role" disabled>Select Role</option>
                          <option  *ngFor="let role of roles | slice:2" [value]="role._id">{{role.type}}</option>
                        </select>
                      </fieldset>
                  </div>                               -->
                  <!--------------------------- Student Form ------------------------------ ---->
                  <div class="form-group">
                    <input
                      type="text"
                      formControlName="name"
                      class="form-control mb-2"
                      placeholder="Enter Name"
                      [ngClass]="{
                        'is-invalid': registerFormSubmitted && rf.name.invalid,
                        'is-valid': registerFormSubmitted && !rf.name.invalid
                      }"
                      required
                    />
                    <div
                      *ngIf="
                        rf.name.touched &&
                        (rf.name.invalid || rf.name.errors?.required)
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Name is
                      required
                    </div>
                  </div>
                  <div class="form-group">
                    <input
                      type="email"
                      formControlName="email"
                      class="form-control mb-2"
                      placeholder="Enter Email"
                      [ngClass]="{
                        'is-invalid': registerFormSubmitted && rf.email.invalid,
                        'is-valid': registerFormSubmitted && !rf.email.invalid
                      }"
                      required
                    />
                    <div
                      *ngIf="
                        rf.email.touched &&
                        (rf.email.invalid || rf.email.errors?.required)
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Email is
                      required
                    </div>
                    <div
                      *ngIf="registerFormSubmitted && rf.email.errors?.email"
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Email must be
                      a valid email address
                    </div>
                  </div>

                  <div class="form-group">
                    <input
                      type="text"
                      formControlName="phone"
                      class="form-control mb-2"
                      placeholder="Enter Phone Number"
                      [ngClass]="{
                        'is-invalid': registerFormSubmitted && rf.phone.invalid,
                        'is-valid': registerFormSubmitted && !rf.phone.invalid
                      }"
                      required
                    />
                    <div
                      *ngIf="
                        rf.phone.touched &&
                        (rf.phone.invalid || rf.phone.errors?.required)
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> phone is
                      required
                    </div>
                    <div
                      *ngIf="
                        rf.phone.errors?.minlength || rf.phone.errors?.maxlength
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> phone no.
                      must be 10 digits
                    </div>
                  </div>
                  <!-- <div class="form-group">
                    <input
                      type="text"
                      formControlName="college"
                      class="form-control mb-2"
                      placeholder="Enter College"
                      [ngClass]="{
                        'is-invalid':
                          registerFormSubmitted && rf.college.invalid,
                        'is-valid': registerFormSubmitted && !rf.college.invalid
                      }"
                      required
                    />
                    <div
                      *ngIf="
                        rf.college.touched &&
                        (rf.college.invalid || rf.college.errors?.required)
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> college is
                      required
                    </div>
                  </div> -->
                  <div class="form-group">
                    <input
                      type="text"
                      formControlName="last_qualification"
                      class="form-control mb-2"
                      placeholder="Enter Last Qualification"
                      [ngClass]="{
                        'is-invalid':
                          registerFormSubmitted &&
                          rf.last_qualification.invalid,
                        'is-valid':
                          registerFormSubmitted &&
                          !rf.last_qualification.invalid
                      }"
                      required
                    />
                    <div
                      *ngIf="
                        rf.last_qualification.touched &&
                        (rf.last_qualification.invalid ||
                          rf.last_qualification.errors?.required)
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> last
                      Qualification is required
                    </div>
                  </div>
                  <!-- <div class="form-group">
                    <ng-select
                      [items]="courseList"
                      bindLabel="courseName"
                      bindValue="_id"
                      [multiple]="true"
                      [closeOnSelect]="false"
                      placeholder="Select Course Interest"
                      [(ngModel)]="selectedValue"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="getCourseId($event)"
                    >
                    </ng-select>
                  </div> -->
                  <div class="form-group">
                    <ng-select
                      [items]="categoryList"
                      bindLabel="name"
                      bindValue="_id"
                      [closeOnSelect]="true"
                      [clearable]="false"
                      placeholder="Select Course Interest"
                      [(ngModel)]="selectedCategory"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="getCategoryId($event)"
                    >
                    </ng-select>
                  </div>
                  <div class="form-group">
                    <ng-select
                      [items]="tagsList"
                      bindLabel="displayname"
                      bindValue="_id"
                      [multiple]="true"
                      [closeOnSelect]="false"
                      placeholder="Select skills"
                      [(ngModel)]="selectedTag"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="getTagsId($event)"
                    >
                    </ng-select>
                  </div>

                  <!-- <div class="form-group">
                    <select
                      id="course-list"
                      class="form-control"
                      [(ngModel)]="selectedValue"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="getCourseId($event)"
                    >
                      <option value="">Select Course</option>
                      <option
                        *ngFor="let course of courseList"
                        [value]="course._id"
                      >
                        {{ course?.courseName }}
                      </option>
                    </select>
                  </div> -->
                  <!-- <div class="form-group" >
                    <ng-select [items]="item"  [multiple]="false" [closeOnSelect]="false"
                      placeholder="Select course" [(ngModel)]="selectedValue" 
                       [ngModelOptions]="{ standalone: true }" (change)="getCourseId($event)"  > 
                    </ng-select>
                  </div>  -->

                  <!-- <div class="form-group">
                    <ng-select
                      [items]="batchList"
                      bindLabel="name"
                      bindValue="_id"
                      [closeOnSelect]="true"
                      placeholder="Select Batch"
                      [(ngModel)]="selectedBatch"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="getBatchId($event)"
                    >
                    </ng-select>
                  </div> -->

                  <!-- <div class="form-group">
                    <input
                      type="file"
                      class="form-control"
                      formControlName="image"
                      id="file-upload"
                      required
                      (change)="onSelectFile($event)"
                    />
                    <label for="file-upload" class="form-control"
                      >Upload Profile Image</label
                    >
                  </div> -->

                  <!--------------------------- End Student Form ------------------------------ ---->
                  <!-- <div class="form-group" >
                <input type="text" formControlName="headshot" class="form-control mb-2" placeholder="Headshot"
                  [ngClass]="{ 'is-invalid': registerFormSubmitted && rf.headshot.invalid, 'is-valid': registerFormSubmitted && !rf.headshot.invalid }"
                  required>
                <div *ngIf="rf.headshot.touched && (rf.headshot.invalid || rf.headshot.errors?.required)"
                  class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> Headshot is
                  required</div>
              </div>
              <div class="form-group">
                <input type="text" formControlName="linked_in" class="form-control mb-2" placeholder="linked_in"
                  [ngClass]="{ 'is-invalid': registerFormSubmitted && rf.linked_in.invalid, 'is-valid': registerFormSubmitted && !rf.linked_in.invalid }"
                  required>
                <div *ngIf="rf.linked_in.touched && (rf.linked_in.invalid || rf.linked_in.errors?.required)"
                  class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> linked_in is
                  required</div>
              </div> 
                  <div class="form-group" >
                    <input type="text" formControlName="address" class="form-control mb-2" placeholder="Address"
                      [ngClass]="{ 'is-invalid': registerFormSubmitted && rf.address.invalid, 'is-valid': registerFormSubmitted && !rf.address.invalid }"
                      required>
                    <div *ngIf="rf.address.touched && (rf.address.invalid || rf.address.errors?.required)"
                      class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> Address is
                      required</div>
                  </div>
                  <div class="form-group">
                    <input type="location" formControlName="location" class="form-control mb-2" placeholder="location"
                      [ngClass]="{ 'is-invalid': registerFormSubmitted && rf.location.invalid, 'is-valid': registerFormSubmitted && !rf.location.invalid }"
                      required>
                    <div *ngIf="rf.location.touched && (rf.location.invalid || rf.location.errors?.required)"
                      class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> Location is
                      required</div>
                  </div>
                  <div class="form-group" >
                    <input type="text" formControlName="phoneNumber" class="form-control mb-2" placeholder="phoneNumber"
                      [ngClass]="{ 'is-invalid': registerFormSubmitted && rf.phoneNumber.invalid, 'is-valid': registerFormSubmitted && !rf.phoneNumber.invalid }"
                      required>
                    <div *ngIf="registerFormSubmitted && (rf.phoneNumber.invalid || rf.phoneNumber.errors?.required)"
                      class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> phone no. is
                      required</div>
                  </div>
                  <div class="form-group"  *ngIf="isManager" >
                    <input type="text" formControlName="position" class="form-control mb-2" placeholder="position"
                      [ngClass]="{ 'is-invalid': registerFormSubmitted && rf.position.invalid, 'is-valid': registerFormSubmitted && !rf.position.invalid }"
                      required>
                    <div *ngIf="registerFormSubmitted && (rf.position.invalid || rf.position.errors?.required)"
                      class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> position is
                      required</div>
                  </div>
                  <div class="form-group" *ngIf="isManager">
                    <input type="text" formControlName="salary" class="form-control mb-2" placeholder="salary"
                      [ngClass]="{ 'is-invalid': registerFormSubmitted && rf.salary.invalid, 'is-valid': registerFormSubmitted && !rf.salary.invalid }"
                      required>
                    <div *ngIf="registerFormSubmitted && (rf.salary.invalid || rf.salary.errors?.required)"
                      class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> salary is
                      required</div>
                  </div>
                  <div class="form-group" >
                    <input type="date" formControlName="DOB" class="form-control mb-2" placeholder="DOB"
                      [ngClass]="{ 'is-invalid': registerFormSubmitted && rf.DOB.invalid, 'is-valid': registerFormSubmitted && !rf.DOB.invalid }"
                      required>
                    <div *ngIf="registerFormSubmitted && (rf.DOB.invalid || rf.DOB.errors?.required)"
                      class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> DOB is
                      required</div>
                  </div>
                 
                  <div class="form-group" >
                    <input type="text" formControlName="address" class="form-control mb-2" placeholder="address"
                      [ngClass]="{ 'is-invalid': registerFormSubmitted && rf.address.invalid, 'is-valid': registerFormSubmitted && !rf.address.invalid }"
                      required>
                    <div *ngIf="registerFormSubmitted && (rf.address.invalid || rf.address.errors?.required)"
                      class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> address is
                      required</div>
                  </div>
                  <div class="form-group" *ngIf="isStudent">
                    <input type="text" formControlName="course" class="form-control mb-2" placeholder="course"
                      [ngClass]="{ 'is-invalid': registerFormSubmitted && rf.course.invalid, 'is-valid': registerFormSubmitted && !rf.course.invalid }"
                      required>
                    <div *ngIf="registerFormSubmitted && (rf.course.invalid || rf.course.errors?.required)"
                      class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> course is
                      required</div>
                  </div>
                  <div class="form-group" *ngIf="isStudent">
                    <input type="text" formControlName="college" class="form-control mb-2" placeholder="college"
                      [ngClass]="{ 'is-invalid': registerFormSubmitted && rf.college.invalid, 'is-valid': registerFormSubmitted && !rf.college.invalid }"
                      required>
                    <div *ngIf="registerFormSubmitted && (rf.college.invalid || rf.college.errors?.required)"
                      class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> college is
                      required</div>
                  </div>
                  <div class="form-group" *ngIf="isStudent">
                    <input type="text" formControlName="trainingPeriod" class="form-control mb-2" placeholder="trainingPeriod"
                      [ngClass]="{ 'is-invalid': registerFormSubmitted && rf.trainingPeriod.invalid, 'is-valid': registerFormSubmitted && !rf.trainingPeriod.invalid }"
                      required>
                    <div *ngIf="registerFormSubmitted && (rf.trainingPeriod.invalid || rf.trainingPeriod.errors?.required)"
                      class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> trainingPeriod is
                      required</div>
                  </div>
                  <div class="form-group" *ngIf="isStudent">
                    <input type="text" formControlName="sessionStarted" class="form-control mb-2" placeholder="sessionStarted"
                      [ngClass]="{ 'is-invalid': registerFormSubmitted && rf.sessionStarted.invalid, 'is-valid': registerFormSubmitted && !rf.sessionStarted.invalid }"
                      required>
                    <div *ngIf="registerFormSubmitted && (rf.sessionStarted.invalid || rf.sessionStarted.errors?.required)"
                      class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> sessionStarted is
                      required</div>
                  </div>
                  <div class="form-group" *ngIf="isStudent">
                    <input type="text" formControlName="courseFee" class="form-control mb-2" placeholder="courseFee"
                      [ngClass]="{ 'is-invalid': registerFormSubmitted && rf.courseFee.invalid, 'is-valid': registerFormSubmitted && !rf.courseFee.invalid }"
                      required>
                    <div *ngIf="registerFormSubmitted && (rf.courseFee.invalid || rf.courseFee.errors?.required)"
                      class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> courseFee is
                      required</div>
                  </div>
                  <div class="form-group" *ngIf="isStudent">
                    <input type="text" formControlName="submittedFee" class="form-control mb-2" placeholder="submittedFee"
                      [ngClass]="{ 'is-invalid': registerFormSubmitted && rf.submittedFee.invalid, 'is-valid': registerFormSubmitted && !rf.submittedFee.invalid }"
                      required>
                    <div *ngIf="registerFormSubmitted && (rf.submittedFee.invalid || rf.nasubmittedFeeme.errors?.required)"
                      class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> submittedFee is
                      required</div>
                  </div>
                  <div class="form-group" *ngIf="isStudent">
                    <input type="text" formControlName="pending" class="form-control mb-2" placeholder="pending"
                      [ngClass]="{ 'is-invalid': registerFormSubmitted && rf.pending.invalid, 'is-valid': registerFormSubmitted && !rf.pending.invalid }"
                      required>
                    <div *ngIf="registerFormSubmitted && (rf.pending.invalid || rf.pending.errors?.required)"
                      class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> pending is
                      required</div>
                  </div>
                  <div class="form-group" *ngIf="isStudent">
                    <input type="text" formControlName="placementStatus" class="form-control mb-2" placeholder="placementStatus"
                      [ngClass]="{ 'is-invalid': registerFormSubmitted && rf.placementStatus.invalid, 'is-valid': registerFormSubmitted && !rf.placementStatus.invalid }"
                      required>
                    <div *ngIf="registerFormSubmitted && (rf.placementStatus.invalid || rf.placementStatus.errors?.required)"
                      class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> placementStatus is
                      required</div>
                  </div> -->
                  <!-- <div class="form-group">
                    <input type="password" formControlName="password" class="form-control mb-2" placeholder="Password"
                      [ngClass]="{ 'is-invalid': registerFormSubmitted && rf.password.invalid, 'is-valid': registerFormSubmitted && !rf.password.invalid }"
                      required>
                    <div *ngIf="registerFormSubmitted && (rf.password.errors?.required)"
                      class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> Password is
                      required
                    </div>
                    <div *ngIf="registerFormSubmitted && (!rf.password.errors?.required && rf.password.errors?.minlength)"
                      class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> Password must be
                      at least 6 characters
                    </div>
                  </div>
                  <div class="form-group">
                    <input type="password" formControlName="confirmPassword" class="form-control mb-2"
                      placeholder="Confirm Password"
                      [ngClass]="{ 'is-invalid': registerFormSubmitted && rf.confirmPassword.invalid, 'is-valid': registerFormSubmitted && !rf.confirmPassword.invalid }"
                      required>
                    <div
                      *ngIf="registerFormSubmitted && (rf.confirmPassword.errors?.required)"
                      class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> Confirm Password is
                      required
                    </div>
                    <div *ngIf="registerFormSubmitted && (rf.confirmPassword.errors?.MustMatch)"
                      class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> Passwords must
                      match
                    </div>
                  </div> -->
                  <!-- <div class="form-group">
                  <div class="checkbox auth-checkbox  ">
                    <input type="checkbox" id="auth-login" formControlName="acceptTerms" class="form-control">
                    <label for="auth-login"><span class="font-small-2 mb-3 font-weight-normal">I accept the terms & conditions</span></label>
                    <div *ngIf="registerFormSubmitted && (rf.acceptTerms.invalid || rf.acceptTerms.errors?.required)"
                      class="help-block mt-1 text-danger"> <i class="ft-alert-circle align-middle"></i> Accept Ts & Cs is required
                    </div>
                  </div>
                  </div> -->
                  <div
                    class="d-flex justify-content-between flex-sm-row flex-column"
                  >
                    <!-- <a [routerLink]="['/login']" class="btn
                      bg-light-primary mb-2 mb-sm-0">Back To Login</a> -->
                    <a class="btn btn-primary" (click)="onSubmit()">Submit</a>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Registration Page Ends-->
